import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressBar", "listItem", "approveButton"]

  connect() {
    this.updateProgress()
  }

  toggleSingle(event) {
    const input = event.target
    const listItem = input.closest('[data-verification-documents-target="listItem"]')
    listItem.classList.toggle("verified-item", input.checked)
    this.updateProgress()
  }

  updateProgress() {
    const items = this.listItemTargets
    const mandatoryItems = items.filter(item => item.dataset.optional === "false")
    const total = mandatoryItems.length
    const verified = mandatoryItems.filter(item => item.querySelector('input[type="checkbox"]').checked).length

    const progress = total > 0 ? Math.round((verified / total) * 100) : 0
    this.progressBarTarget.style.width = `${progress}%`
    this.progressBarTarget.textContent = `${progress}% Complete`
    this.progressBarTarget.classList.toggle("bg-success", progress === 100 && total > 0)
    this.progressBarTarget.classList.toggle("bg-warning", !(progress === 100 && total > 0))
  }

  // Called only after Save Verification button click
  onSaveClick(event) {
    // Wait for form submission to complete (we assume success)
    setTimeout(() => {
      const progress = parseInt(this.progressBarTarget.textContent)
      if (progress === 100 && this.hasApproveButtonTarget) {
        this.approveButtonTarget.classList.remove("d-none")
      } else if (this.hasApproveButtonTarget) {
        this.approveButtonTarget.classList.add("d-none")
      }
    }, 50)
  }
}
